module.exports = __webpack_public_path__ + "img/28.20dd9b2f.jpg";